import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import classNames from 'classnames';

import { Helmet } from 'react-helmet';
// import ReactGA from 'react-ga';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';
import Media from 'reactstrap/lib/Media';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import Popover from 'reactstrap/lib/Popover';
import PopoverBody from 'reactstrap/lib/PopoverBody';
// import Spinner from 'reactstrap/lib/Spinner';
import Input from 'reactstrap/lib/Input';

import ScrollAreaWrapper from '../UI/ScrollAreaWrapper';

import Leaderboard from './TournamentLeaderboard';
import CustomDate from '../UI/CustomDate';

import tournamentsImg from '../../../images/icons/tournaments.webp';
import coinImg from '../../../images/coin.svg';
import closeImg from '../../../images/icons/close.png';
import coinStack from '../../../images/redesign/icons/coinStack.svg';

// import keyImg from '../../../images/icons/private.svg';
// import speedImg from '../../../images/icons/fast_game.svg';
// import lightningImg from '../../../images/icons/fast_game_lightning.svg';

import tutorialImage from '../../../images/icons/help2.webp';

// import infoImg from '../../../images/icons/info_chats.svg';

import {
  getTournamentPlayers,
  getTournamentActiveRooms,
  joinTournament,
  leaveTournament,
  returnToTournament,
  pauseTournament,
} from '../../../actions/tournaments';

import {
  FONT_MODE,
  MENU_NAVIGATION,
  CALC_TOURNAMENT_ROUND_LENGTH,
  PAYMENT_SOURCE,
  TOURNAMENT_TICKETS,
  TOURNAMENT_TICKET_TYPES,
  SCREENS,
} from '../../../constants/constants';
import { getFutureTournaments, getTournamentById, getTournamentTitle, getTournamentType } from '../../../utils/tournamentUtils';
import { FormGroup, Label } from 'reactstrap';
import { addPaymentInfo, updatePaymentInfoStatus } from '../../../actions/shop';
import { includes } from 'lodash';
import { renderNum } from '../../../utils/stringUtils';
import { setUserScreenViewNew } from '../../../actions/member';
import { setJoinTournamentIdTrigger, setOpenLuckyWheelHistoryTrigger } from '../../../actions/state';
import TournamentInfo from './TournamentInfo';


/*
class TournamentTimer extends React.Component {
  static propTypes = {
    time: PropTypes.number,
    offset: PropTypes.number,
    t: PropTypes.func.isRequired,
    fontMode: PropTypes.string,
  }

  static defaultProps = {
    time: 0,
    offset: 0,
    fontMode: FONT_MODE.normal,
  }

  constructor(props) {
    super(props);
    this.state = {
      minutes: 0,
      seconds: 0,
    };
  }

  componentDidMount() {
    const { time } = this.props;

    if (time) {
      const gameLength = time - (Date.now() + this.props.offset);
      const minutes = Math.floor((gameLength % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((gameLength % (1000 * 60)) / 1000);

      if (minutes >= 0 && seconds >= 0) {
        this.setState({
          minutes: minutes < 10 ? `0${minutes}` : minutes,
          seconds: seconds < 10 ? `0${seconds}` : seconds,
        });
      }
    }

    this.intervalID = setInterval(() => {
      const { offset } = this.props;

      if (time) {
        const gameLength = time - (Date.now() + offset);
        const minutes = Math.floor((gameLength % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((gameLength % (1000 * 60)) / 1000);

        if (minutes >= 0 && seconds >= 0) {
          this.setState({
            minutes: minutes < 10 ? `0${minutes}` : minutes,
            seconds: seconds < 10 ? `0${seconds}` : seconds,
          });
        }
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  render() {
    const { time, t } = this.props;
    const { minutes, seconds } = this.state;

    if (!time) return null;

    return (
      ` (${t('tournaments.newRoundIn')} ${minutes}:${seconds})`
    );
  }
}


class PopoverEndTimer extends React.Component {
  static propTypes = {
    time: PropTypes.number,
    offset: PropTypes.number,
  }

  static defaultProps = {
    time: 0,
    offset: 0,
  }

  constructor(props) {
    super(props);
    this.state = {
      minutes: 0,
      seconds: 0,
    };
  }

  componentDidMount() {
    const { time, offset: offsetVal } = this.props;

    if (time) {
      const gameLength = time - (Date.now() + offsetVal);
      const minutes = Math.floor((gameLength % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((gameLength % (1000 * 60)) / 1000);

      if (minutes >= 0 && seconds >= 0) {
        this.setState({
          minutes: minutes < 10 ? `0${minutes}` : minutes,
          seconds: seconds < 10 ? `0${seconds}` : seconds,
        });
      }
    }

    this.intervalID = setInterval(() => {
      const { offset } = this.props;

      console.log('time', time);

      if (time) {
        const gameLength = time - (Date.now() + offset);
        const minutes = Math.floor((gameLength % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((gameLength % (1000 * 60)) / 1000);

        if (minutes >= 0 && seconds >= 0) {
          this.setState({
            minutes: minutes < 10 ? `0${minutes}` : minutes,
            seconds: seconds < 10 ? `0${seconds}` : seconds,
          });
        }
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  render() {
    const { time } = this.props;
    const { minutes, seconds } = this.state;

  //  console.log('time', time, minutes, seconds);

    if (!time) return null;

    return (
      `${minutes}:${seconds}`
    );
  }
}  */

class TournamentsPlan extends React.PureComponent {
  static propTypes = {
    tournaments: PropTypes.arrayOf(PropTypes.shape()),
    tournamentPlayers: PropTypes.shape(),
    myTournamentsData: PropTypes.shape(),
    registeredTournament: PropTypes.shape(),
    // offset: PropTypes.number,
    uid: PropTypes.string,
    t: PropTypes.func.isRequired,
    joinTournamentFunc: PropTypes.func.isRequired,
    leaveTournamentFunc: PropTypes.func.isRequired,
    returnToTournamentFunc: PropTypes.func.isRequired,
    pauseTournamentFunc: PropTypes.func.isRequired,
    changeTab: PropTypes.func.isRequired,
    fetchTournamentPlayers: PropTypes.func.isRequired,
    fetchTournamentActiveRooms: PropTypes.func.isRequired,
    toggleShowTournamentTutorial: PropTypes.func.isRequired,
    fontMode: PropTypes.string,
    name: PropTypes.string,
    setHandlePaymentInfoStatus: PropTypes.func.isRequired,
    setAddPaymentInfo: PropTypes.func.isRequired,
    member: PropTypes.shape({}),
    setScreenViewNew: PropTypes.func.isRequired,
    setJoinTournamentIdTriggerFunc: PropTypes.func.isRequired,
    joinTournamentIdTrigger: PropTypes.string,
  }

  static defaultProps = {
    tournaments: [],
    tournamentPlayers: null,
    myTournamentsData: null,
    registeredTournament: null,
    uid: null,
    // offset: 0,
    fontMode: FONT_MODE.normal,
    name: '',
    member: {},
  }

  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      openJoinModal: false,
      tournamentId: '',
      // scrollPos: 0,
      tournamentToJoin: null,
      tournamentToJoinFee: null,
      registerPopoverOpen: {},
      privateTournamentConfirm: false,
      privateTournamentConfirmError: '',
      tournamentConfirmError: '',
      privateTournamentId: '',
      password: [],
      lowBalanceError: false,
      tournamentInfoModalOpen: false,
      selectTournament: {},
      disableAutoJoin: false,
      curLength: 0,
      purchaseTournamentTicketModal: false,
      confirmTournamentTicketModal: false,
      confirmTournamentRoom: '',
      selectedTournamentId: '',
      selectedTournamentFee: null,
      isRestrictionModal: false,
    };

    this.digit1 = React.createRef();
    this.digit2 = React.createRef();
    this.digit3 = React.createRef();
    this.digit4 = React.createRef();
  }

  componentDidMount() {
    const { setScreenViewNew, member, tournaments, setJoinTournamentIdTriggerFunc, joinTournamentIdTrigger } = this.props;
    setScreenViewNew(SCREENS.TOURNAMENTS.FUTURE);

    if (joinTournamentIdTrigger) {
      const tournament = tournaments.find(element => element.id === joinTournamentIdTrigger);

      if (tournament) {
        if (TOURNAMENT_TICKET_TYPES.includes(tournament.tournamentType) && !(member?.tournamentTickets && member?.tournamentTickets[tournament.tournamentType])) {
          this.confirmTournamentTicket(tournament.id, tournament.entryFee, "private")
        } else {
          this.joinPrivateTournamentConfirm(tournament.id, tournament.entryFee);
        }
      }
      setJoinTournamentIdTriggerFunc(null);
    }
  }

  componentDidUpdate() {
    const { member, tournaments, setJoinTournamentIdTriggerFunc, joinTournamentIdTrigger } = this.props;
    if (joinTournamentIdTrigger) {
      const tournament = tournaments.find(element => element.id === joinTournamentIdTrigger);

      if (tournament) {
        if (TOURNAMENT_TICKET_TYPES.includes(tournament.tournamentType) && !(member?.tournamentTickets && member?.tournamentTickets[tournament.tournamentType])) {
          this.confirmTournamentTicket(tournament.id, tournament.entryFee, "private")
        } else {
          this.joinPrivateTournamentConfirm(tournament.id, tournament.entryFee);
        }
      }
      setJoinTournamentIdTriggerFunc(null);
    }
  }

  handleChangeDigit = (e) => {
    const { password } = this.state;

    console.log('handleChangeDigit', password);

    const newPassword = [...password];

    if (e.target) {
      const { value, name } = e.target;

      const newVal = value.charAt(value.length - 1);

      if (!isNaN(newVal) || !newVal) {
        newPassword[name] = newVal;

        if (newVal) {
          if (name === 0 || name === '0') {
            if (this.digit2) {
              this.digit2.current.focus();
            }
          }
          if (name === 1 || name === '1') {
            if (this.digit3) {
              this.digit3.current.focus();
            }
          }
          if (name === 2 || name === '2') {
            if (this.digit4) {
              this.digit4.current.focus();
            }
          }
        }

        console.log('handleChangeDigit 2', newPassword);

        this.setState({
          password: newPassword,
        });
      }
    }
  }

  checkRange = (value, from, to) => {
    if (from !== null && to !== null) return value >= from && value <= to;
    if (from !== null) return value >= from;
    if (to !== null) return value <= to;
    return true;
  };

  checkRestrictionsFunc = (tournament) => {
    const { member } = this.props;

    const {
      lvl, bal, totalPnts, gPlayed,
    } = member;
    const levelFrom = (tournament.levelFrom || tournament.levelFrom === 0) ? parseInt(tournament.levelFrom, 10) : null;
    const levelTo = (tournament.levelTo || tournament.levelTo === 0) ? parseInt(tournament.levelTo, 10) : null;
    const pointsFrom = (tournament.pointsFrom || tournament.pointsFrom === 0) ? parseInt(tournament.pointsFrom, 10) : null;
    const pointsTo = (tournament.pointsTo || tournament.pointsTo === 0) ? parseInt(tournament.pointsTo, 10) : null;
    const balanceFrom = (tournament.balanceFrom || tournament.balanceFrom === 0) ? parseInt(tournament.balanceFrom, 10) : null;
    const balanceTo = (tournament.balanceTo || tournament.balanceTo === 0) ? parseInt(tournament.balanceTo, 10) : null;
    const playedGamesFrom = (tournament.playedGamesFrom || tournament.playedGamesFrom === 0) ? parseInt(tournament.playedGamesFrom, 10) : null;
    const playedGamesTo = (tournament.playedGamesTo || tournament.playedGamesTo === 0) ? parseInt(tournament.playedGamesTo, 10) : null;

    const isLevelPass = this.checkRange(lvl, levelFrom, levelTo);
    const isPointsPass = this.checkRange(totalPnts, pointsFrom, pointsTo);
    const isBalPass = this.checkRange(bal, balanceFrom, balanceTo);
    const isPlayedGamesPass = this.checkRange(gPlayed, playedGamesFrom, playedGamesTo);

    if (isLevelPass && isPointsPass && isBalPass && isPlayedGamesPass) {
      return false;
    } else {
      return true;
    }
  }

  joinTournamentNotification = (tournamentId, fee) => {
    const { tournaments, registeredTournament, joinTournamentFunc, member } = this.props;

    const tournament = tournaments.find(element => element.id === tournamentId);

    if (tournament.restrictions) {
      const checkRestrictions = this.checkRestrictionsFunc(tournament);
      if (checkRestrictions) {
        this.setState({
          isRestrictionModal: true,
          selectedTournamentId: tournament.id,
        })
        return;
      }
    }

    if (tournament && !(tournament.registeredPlayers >= tournament.maxPlayers) && !registeredTournament) {
      if (tournament?.tournamentType && TOURNAMENT_TICKET_TYPES.includes(tournament?.tournamentType)) {
        const value = TOURNAMENT_TICKETS[tournament?.tournamentType];

        if (member?.tournamentTickets && member?.tournamentTickets[tournament?.tournamentType]) {
          joinTournamentFunc('init');

          this.setState({
            openJoinModal: true,
            tournamentToJoin: tournamentId,
            tournamentToJoinFee: fee,
          });
        } else {
          this.setState({
            purchaseTournamentTicketModal: true,
          })
        }
      } else {
        joinTournamentFunc('init');

        this.setState({
          openJoinModal: true,
          tournamentToJoin: tournamentId,
          tournamentToJoinFee: fee,
        });
      }
      this.closeTournamentTicketModal();
    }
  }

  toggleJoin = () => {
    this.setState(prevState => ({
      openJoinModal: !prevState.openJoinModal,
    }));
  }

  closePrivateTournamentEnter = () => {
    this.setState({
      password: [], privateTournamentConfirm: false, privateTournamentId: '', privateTournamentConfirmError: '',
    });
  }

  joinPrivateTournamentConfirm = (tournamentId, fee) => {
    const { tournaments, registeredTournament, joinTournamentFunc, member } = this.props;
    const tournament = tournaments.find(element => element.id === tournamentId);
    if (tournament.restrictions) {
      const checkRestrictions = this.checkRestrictionsFunc(tournament);
      if (checkRestrictions) {
        this.setState({
          isRestrictionModal: true,
          selectedTournamentId: tournament.id,
        })
        return;
      }
    }

    if (tournament && !(tournament.registeredPlayers >= tournament.maxPlayers) && !registeredTournament) {
      if (tournament?.tournamentType && TOURNAMENT_TICKET_TYPES.includes(tournament?.tournamentType)) {
        const value = TOURNAMENT_TICKETS[tournament?.tournamentType];

        if (member?.tournamentTickets && member?.tournamentTickets[tournament?.tournamentType]) {
          joinTournamentFunc('init');

          this.setState({
            tournamentToJoin: tournamentId,
            tournamentToJoinFee: fee,
            privateTournamentConfirm: true,
            privateTournamentId: tournamentId,
            privateTournamentConfirmError: '',
            disableAutoJoin: false,
          });
        } else {
          this.setState({
            purchaseTournamentTicketModal: true,
          })
        }
      } else {
        joinTournamentFunc('init');

        this.setState({
          tournamentToJoin: tournamentId,
          tournamentToJoinFee: fee,
          privateTournamentConfirm: true,
          privateTournamentId: tournamentId,
          privateTournamentConfirmError: '',
          disableAutoJoin: false,
        });
      }
      this.closeTournamentTicketModal();
    }
  }

  joinPrivateTournamentClicked = () => {
    const { joinTournamentFunc, updateModal, openModal, modalType } = this.props;
    const { privateTournamentId, password } = this.state;

    if (!privateTournamentId) {
      return null;
    }

    if (password && password.length === 4) {
      const passString = password.join('');

      joinTournamentFunc(privateTournamentId, passString).then((res) => {
        if (res && res.status === 'success') {
          this.setState({
            password: [], privateTournamentConfirm: false, privateTournamentId: '', privateTournamentConfirmError: '',
          });

          setTimeout(() => {
            this.setState({
              openJoinModal: false,
              tournamentToJoin: '',
              tournamentToJoinFee: '',
            });
          }, 250);
        } else if (res.error === 'wrong password') {
          this.setState({ privateTournamentConfirmError: 'tournamentWrongPassword', password: [] }); // Nepareizs kods
        } else if (res.error === 'multiAccount') {
          //this.setState({ privateTournamentConfirmError: 'multiAccount', multiAccountErrorName: res.name }); // multiAccount blocked
          if (!(openModal && modalType === 'multiAccountTournament')) {
            updateModal(true, 'multiAccountTournament', null, null, null);
            this.setState({
              password: [], privateTournamentConfirm: false, privateTournamentId: '', privateTournamentConfirmError: '',
            });
          }
        } else if (res.error === 'tournament already registered') {
          this.setState({
            password: [], privateTournamentConfirm: false, privateTournamentId: '', privateTournamentConfirmError: '',
          });

          setTimeout(() => {
            this.setState({
              openJoinModal: false,
              tournamentToJoin: '',
              tournamentToJoinFee: '',
            });
          }, 250);
        } else if (res.error === 'tournament max players') {
          this.setState({ privateTournamentConfirmError: 'tournamentFull', password: [] }); // Turnīrs pilns
        } else if (res.error === 'insuf bal tournament') {
          const { tournaments } = this.props;
          this.setState({ privateTournamentConfirmError: 'noBalanceTournament', lowBalanceError: true, selectTournament: { ...tournaments.filter(tournament => tournament.id === privateTournamentId)[0] }, disableAutoJoin: true, password: [] });
        } else if (res.error === 'pro room') {
          if (!(openModal && modalType === 'tournamentProError')) {
            updateModal(true, 'tournamentProError', null, null, null);
            this.setState({
              password: [], privateTournamentConfirm: false, privateTournamentId: '', privateTournamentConfirmError: '',
            });
          }
        } else {
          this.setState({ privateTournamentConfirmError: 'tournamentError', password: [] }); // Radās kļūda pievienojoties, mēģini vēlreiz
        }
      });
    } else {
    //  console.log('no password');
    }

    return null;
  }

  joinTournament = (tournamentId) => {
    const { joinTournamentFunc, updateModal, openModal, modalType } = this.props;

    if (tournamentId) {
      joinTournamentFunc(tournamentId).then((res) => {
        if (res && res.status === 'success') {
          setTimeout(() => {
            this.setState({
              openJoinModal: false,
              tournamentToJoin: '',
              tournamentToJoinFee: '',
            });
          }, 250);
        } else if (res.error === 'multiAccount') {
          //this.setState({ tournamentConfirmError: 'multiAccount', multiAccountErrorName: res.name }); // multiAccount blocked

          if (!(openModal && modalType === 'multiAccountTournament')) {
            updateModal(true, 'multiAccountTournament', null, null, null);
          }

        } else if (res.error === 'tournament already registered') {
          setTimeout(() => {
            this.setState({
              openJoinModal: false,
              tournamentToJoin: '',
              tournamentToJoinFee: '',
            });
          }, 250);
        } else if (res.error === 'tournament max players') {
          this.setState({ tournamentConfirmError: 'tournamentFull' }); // Turnīrs pilns
        } else if (res.error === 'insuf bal tournament') {
          const { tournaments } = this.props;
          this.setState({ tournamentConfirmError: 'noBalanceTournament', lowBalanceError: true, selectTournament: {...tournaments.filter(tournament  => tournament.id === tournamentId)[0]} });
        } else if (res.error === 'pro room') {
          if (!(openModal && modalType === 'tournamentProError')) {
            updateModal(true, 'tournamentProError', null, null, null);
          }
        } else {
          this.setState({ tournamentConfirmError: 'tournamentError' }); // Radās kļūda pievienojoties, mēģini vēlreiz
        }
      });
    }

    setTimeout(() => {
      this.setState({
        openJoinModal: false,
        tournamentToJoin: '',
        tournamentToJoinFee: '',
      });
    }, 250);
  }

  closeLowBalanceError = () => {
    this.setState({
      lowBalanceError: false,
      tournamentConfirmError: '',
    });
  }

  buyMoney = () => {
    const { changeTab, uid, name, setAddPaymentInfo } = this.props;
    const { lowBalanceError } = this.state;

    if (lowBalanceError) {
      setAddPaymentInfo({
        uid,
        name,
        source: PAYMENT_SOURCE.joinTournament,
      });
    }
    changeTab(MENU_NAVIGATION.buyPageMoneyPacks);
  }

  openModal = (id) => {
    this.setState({
      tournamentId: id,
      openModal: true,
    });
  }

   toggle = () => {
     this.setState(prevState => ({
       openModal: !prevState.openModal,
     }));
   }

  toggleLeave = () => {
    this.setState(prevState => ({
      openLeaveModal: !prevState.openLeaveModal,
    }));
  }

  leaveTournamentNotification = (tournamentId, tournamentFee) => {
    const { leaveTournamentFunc } = this.props;

    if (tournamentId) {
      leaveTournamentFunc('init');
    }

    this.setState({
      openLeaveModal: true,
      tournamentToLeave: tournamentId,
      tournamentToLeaveFee: tournamentFee,

    });
  }

  leaveTournament = (tournamentId) => {
    const { leaveTournamentFunc } = this.props;
    const { leaveReason } = this.state;

    if (tournamentId) {
      leaveTournamentFunc(tournamentId, leaveReason);
    }

    setTimeout(() => {
      this.setState({
        openLeaveModal: false,
        tournamentToLeave: '',
        tournamentToLeaveFee: '',
        leaveReason: '',
      });
    }, 250);
  }

  fetchTournamentPlayers = (tournamentId) => {
    const { fetchTournamentPlayers } = this.props;

    console.log('fetchTournamentPlayers', tournamentId);

    if (tournamentId) {
      fetchTournamentPlayers(tournamentId).then(() => {
        this.setState({
          openModal: true,
          tournamentId: tournamentId,
        });
      });
    }
  }

  fetchTournamentActiveRooms = (tournamentId) => {
    const { fetchTournamentActiveRooms, tournaments } = this.props;
    const { popoverOpen } = this.state;

    if (popoverOpen && popoverOpen === tournamentId) {
      this.setState({ popoverOpen: null });
    } else if (tournamentId) {
      fetchTournamentActiveRooms(tournamentId).then((res) => {
        const tournament = tournaments.find(element => element.id === tournamentId);

        console.log('fetchTournamentActiveRooms res.data', res.data);

        if (res && res.data) {
          const roomsCount = Object.keys(res.data).length;
          let partiesCount = 0;

          Object.keys(res.data).map((key) => {
            if (res.data[key] && res.data[key].party) {
              partiesCount += parseInt(res.data[key].party, 10);
            }
            return null;
          });

          console.log('gameStartTime tournament', tournament);

          const { roundLength, gameStartTime, fastGame, lightningGame, veryFastGame } = tournament;
          let { roundLengthTime } = tournament;
          const averageParties = partiesCount / roomsCount;
          const averagePartiesLeft = Math.round(parseInt(roundLength, 10) - averageParties);

          console.log('gameStartTime', gameStartTime);

          let speed = 'normal';

          if (fastGame) {
            speed = 'atra';
          } else if (lightningGame) {
            speed = 'lightning';
          } else if (veryFastGame) {
            speed = 'veryFast';
          }

          if (!roundLengthTime) {
            roundLengthTime = CALC_TOURNAMENT_ROUND_LENGTH(roundLength, speed);
          }

          let gameEndTime = gameStartTime + (roundLengthTime * 60 * 1000);

          /*if (roundLength > 24) {
            gameEndTime = gameStartTime + (60 * 60 * 1000);
          } else if (roundLength > 12) {
            gameEndTime = gameStartTime + (40 * 60 * 1000);
          } */

          console.log('gameEndTime', gameEndTime);

          this.setState({
            popoverOpen: tournamentId,
            popoverEndTime: gameEndTime,
            popoverRoomsCount: roomsCount,
            popoverPartiesCount: roomsCount > 0 ? averagePartiesLeft : 0,
          });
        }
      });
    }
  }

  togglePopover = () => {
    this.setState({ popoverOpen: null });
  }

  /*
  updateScrollPos = (val) => {
    if (val.topPosition || val.topPosition === 0) {
      this.setState({ scrollPos: val.topPosition || 0 });
    }
  } */

  scroll = (newVal) => {
    this.tableScrollbar.scrollYTo(newVal);
  }

  onRegisterHover = (id) => {
    const { registerPopoverOpen } = this.state;
    if (registerPopoverOpen && !registerPopoverOpen[id]) {
      this.setState(prevState => ({
        registerPopoverOpen: {
          ...prevState.registerPopoverOpen,
          [id]: true,
        },
      }));
    }
  }

  onRegisterHoverLeave = (id) => {
    this.setState(prevState => ({
      registerPopoverOpen: {
        ...prevState.registerPopoverOpen,
        [id]: false,
      },
    }));
  }

  openTournamentInfoModal = (selectId) => {
    const { tournaments, setScreenViewNew } = this.props;
    setScreenViewNew(SCREENS.TOURNAMENTS.INFO);

    this.setState({
      tournamentInfoModalOpen: true,
      selectTournament: { ...tournaments.filter(tournament => tournament.id === selectId)[0] }
    });
  }

  closeTournamentInfoModal = () => {
    this.setState({
      tournamentInfoModalOpen: false,
    });
  }

  handleLeaveReason = (event) => {
    this.setState({ leaveReason: event.target.value, curLength: event.target.value.length });
  }

  tournamentTicketBuyMoney = () => {
    const { changeTab, uid, name, setAddPaymentInfo, member, tournaments } = this.props;
    const { confirmTournamentRoom, selectedTournamentId, selectedTournamentFee } = this.state;

    const tournament = tournaments.find(element => element.id === selectedTournamentId);
    const value = TOURNAMENT_TICKETS[tournament?.tournamentType];

    if (tournament.restrictions) {
      const checkRestrictions = this.checkRestrictionsFunc(tournament);
      if (checkRestrictions) {
        this.setState({
          isRestrictionModal: true,
          selectedTournamentId: tournament.id,
        })
        return;
      }
    }

    if (member?.tournamentTickets && includes(member?.tournamentTickets, tournament?.tournamentType) ) {
      if (confirmTournamentRoom === 'private') {
        this.joinPrivateTournamentConfirm(selectedTournamentId, selectedTournamentFee);
      } else {
        this.joinTournamentNotification(selectedTournamentId, selectedTournamentFee);
      }
    } else {
      setAddPaymentInfo({
        uid,
        name,
        source: PAYMENT_SOURCE.joinTournament,
      });

      changeTab(MENU_NAVIGATION.tournamentTickets);
    }
    this.setState({
      confirmTournamentRoom: '',
      selectedTournamentId: '',
      selectedTournamentFee: null,
      confirmTournamentTicketModal: false,
    })
  }

  closeTournamentTicketModal = () => {
    this.setState({
      selectedTournamentFee: null,
      selectedTournamentId: null,
      confirmTournamentTicketModal: false,
      confirmTournamentRoom: ''
    })
  }

  togglePurchaseTournamentTicketModal = () => {
    this.setState({
      purchaseTournamentTicketModal: false,
    })
  }

  confirmTournamentTicket = (selectedTournamentId, selectedTournamentFee, type) => {
    const { tournaments, member } = this.props;
    const filteredData = tournaments.find(item => item.id === selectedTournamentId);
    if (filteredData.restrictions) {
      const checkRestrictions = this.checkRestrictionsFunc(filteredData);
      if (checkRestrictions) {
        this.setState({
          isRestrictionModal: true,
          selectedTournamentId: filteredData.id,
        })
        return;
      }
    }

    this.setState({
      confirmTournamentTicketModal: true,
      confirmTournamentRoom: type,
      selectedTournamentId,
      selectedTournamentFee
    })
  }

  closeRestrictionsModal = () => {
    this.setState({
      isRestrictionModal: false,
      selectedTournamentId: '',
    })
  }

  render() {
    const {
      t,
      tournaments,
      myTournamentsData,
      //  member,
      registeredTournament,
      uid,
      // offset,
      changeTab,
      tournamentPlayers,
      returnToTournamentFunc,
      pauseTournamentFunc,
      toggleShowTournamentTutorial,
      fontMode,
      member
    } = this.props;

    const {
      openModal,
      tournamentId,
      tournamentToJoin,
      tournamentToJoinFee,
      openJoinModal,
      tournamentToLeave,
      tournamentToLeaveFee,
      openLeaveModal,
      //  scrollPos,
      registerPopoverOpen,
      privateTournamentConfirm,
      privateTournamentConfirmError,
      tournamentConfirmError,
      password,
      // popoverOpen,
      // popoverRoomsCount,
      // popoverPartiesCount,
      // popoverEndTime,
      lowBalanceError,
      selectTournament,
      tournamentInfoModalOpen,
      disableAutoJoin,
      leaveReason,
      curLength,
      purchaseTournamentTicketModal,
      confirmTournamentTicketModal,
      selectedTournamentId,
      isRestrictionModal,
      leaveReasonErr,
    } = this.state;

    if (privateTournamentConfirm) {
      if (this.digit1.current && (!password[0] || password[0] === '')) {
        this.digit1.current.focus();
      } else if (password[0] && password[0] !== '' && password[1] && password[1] !== '' && password[2] && password[2] !== '' && password[3] && password[3] !== '' && !disableAutoJoin) {
        this.joinPrivateTournamentClicked();
      }
    }

    const futureTournaments = getFutureTournaments(tournaments);

    return (
      <>
        <Helmet>
          <title>
            {`Zole - ${t('route.tournaments')}`}
          </title>
        </Helmet>

        {(futureTournaments && futureTournaments.length > 0) ? (
          <ScrollAreaWrapper
            className={`tournaments-scrollarea tournaments-scrollarea-font-based-margin-${fontMode}`}
            contentClassName="tournaments-scrollarea-body"
            show={tournaments && tournaments.length > 7 ? true : null}
            rightOffset={17}
            topOffset={54}
            bottomOffset={17}
            disableAutoHeight={futureTournaments.length === 0}
          >
            {(futureTournaments.map((tournament) => {
              const { startDate, registerTime } = tournament;
              let registerDate;

              if (startDate && registerTime) {
                registerDate = startDate - (registerTime * 1000 * 60);
              }
              return (
                <>
                  <Fragment key={tournament.id}>
                    <div className={classNames('active-tournaments')}>
                      <div className="active-tournaments-info">
                        <div className="active-tournaments-info-section">
                          <div className="active-tournaments-info-section-title">
                            <div className="active-tournaments-info-section-title-left">
                              <Media
                                src={tutorialImage}
                                onClick={() => this.openTournamentInfoModal(tournament.id)}
                                className="active-tournaments-info-section-title-left-img"
                                alt="x"
                              />
                              <span className="active-tournaments-info-section-title-left-title">{getTournamentTitle(tournament)}</span>
                              <span className="active-tournaments-info-section-title-left-private first-capitial">
                                {getTournamentType(tournament, t)}
                              </span>
                            </div>
                            <div className='d-flex flex-row gap-5'>
                              {tournament?.restrictions && (
                                <div className={classNames('active-tournaments-info-section-title-right history-tournaments-info-section-title-right')}>
                                  <div>{t(`common.restrictions`)}</div>
                                </div>
                              )}
                              <div className={classNames('active-tournaments-info-section-title-right plan-tournaments-info-section-title-right', {
                                'plan-tournaments-info-section-title-right-confirmed': registeredTournament === tournament.id
                              })}>
                                <div>{t(`tournaments.${tournament.currentState}`)}</div>
                              </div>
                            </div>
                          </div>
                          <div className="active-tournaments-info-section-time">
                            <span className="active-tournaments-info-section-time-rounds">{`${t('tournaments.rounds')}:`}</span>
                            <span className="active-tournaments-info-section-time-roundsValue">{tournament.rounds}</span>
                            <span className="active-tournaments-info-section-time-label">{`${t('tournaments.beginning')}:`}</span>
                            <span className="active-tournaments-info-section-time-content"><CustomDate format="DD.MM.YYYY hh:mm" date={startDate} /></span>
                          </div>
                        </div>
                        <div className="active-tournaments-info-button">
                          {tournament.currentState && tournament.currentState === 'registration' && (
                            <Fragment>
                              <Button color="link" className="btn notification-footer-button" onClick={() => this.fetchTournamentPlayers(tournament.id)}>{t('tournaments.players')}</Button>
                              {registeredTournament === tournament.id ? (
                                myTournamentsData && tournament.currentState === 'registration' && tournament.startDate && (tournament.startDate - (1000 * 30) < Date.now()) ? (
                                  <Fragment>
                                    {/* {myTournamentsData.paused ? (
                                      <Button color="link" disabled={tournament.rounds === tournament.currentRound} className="btn notification-footer-button" onClick={(e) => { returnToTournamentFunc(tournament.id); e.target.blur(); }}>
                                        {t('tournaments.return')}
                                      </Button>
                                    ) : (
                                      <Button color="link" disabled={tournament.rounds === tournament.currentRound} className="btn notification-footer-button" onClick={(e) => { pauseTournamentFunc(tournament.id); e.target.blur(); }}>
                                        {t('tournaments.pause')}
                                      </Button>
                                    )} */}
                                  </Fragment>
                                ) : (
                                  <Button color="link" className="btn notification-footer-button" onClick={() => this.leaveTournamentNotification(tournament.id, tournament.entryFee)}>
                                    {t('tournaments.leave')}
                                  </Button>
                                )
                              ) : (
                                <Fragment>
                                  <div
                                    id={`tournament-popover-${tournament.id}`}
                                    onMouseEnter={() => this.onRegisterHover(tournament.id)}
                                    onMouseLeave={() => this.onRegisterHoverLeave(tournament.id)}
                                    style={{width: '35%'}}
                                  >
                                    {tournament.privateTournament ? (
                                      <Button
                                        color="link"
                                        className={`btn notification-footer-button w-100 ${((tournament.registeredPlayers >= tournament.maxPlayers) || registeredTournament) && 'disabled'}`}
                                        onClick={() => (TOURNAMENT_TICKET_TYPES.includes(tournament.tournamentType) && !(member?.tournamentTickets && member?.tournamentTickets[tournament.tournamentType])) ? this.confirmTournamentTicket(tournament.id, tournament.entryFee, "private") : this.joinPrivateTournamentConfirm(tournament.id, tournament.entryFee)}
                                      >
                                        {t('tournaments.register')}
                                      </Button>
                                    ) : (
                                      <Button
                                        color="link"
                                        className={`btn notification-footer-button w-100 ${((tournament.registeredPlayers >= tournament.maxPlayers) || registeredTournament) && 'disabled'}`}
                                        onClick={() => (TOURNAMENT_TICKET_TYPES.includes(tournament.tournamentType) && !(member?.tournamentTickets && member?.tournamentTickets[tournament.tournamentType])) ? this.confirmTournamentTicket(tournament.id, tournament.entryFee) : this.joinTournamentNotification(tournament.id, tournament.entryFee)}
                                      >
                                        {t('tournaments.register')}
                                      </Button>
                                    )}
                                  </div>
                                  {((tournament.registeredPlayers && tournament.maxPlayers && parseInt(tournament.registeredPlayers) >= parseInt(tournament.maxPlayers)) || registeredTournament) ? (
                                    <Popover container={'div > div'} popperClassName="last-round-popover" placement="top" isOpen={registerPopoverOpen[tournament.id]} target={`tournament-popover-${tournament.id}`}>
                                      <PopoverBody className="last-round-popover-body">
                                        {registeredTournament ? (
                                          <div>
                                            {t('tournaments.alreadyRegisteredAnotherTournament')}
                                          </div>
                                        ) : (
                                          <>
                                            {tournament.registeredPlayers && tournament.maxPlayers && parseInt(tournament.registeredPlayers) >= parseInt(tournament.maxPlayers) && (
                                              <div>
                                                {t('tournaments.tournamentMaxPlayers2')}
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </PopoverBody>
                                    </Popover>
                                  ) : (null)}
                                </Fragment>
                              )}
                            </Fragment>
                          )}
                        </div>
                      </div>
                      <div className={
                        classNames('active-tournaments-sponsor', {
                          'active-tournaments-sponsor-two': tournament?.sponsorImg && tournament?.prizeImg
                        })}
                      >
                        {
                          tournament?.sponsorImg && (
                            <div className={
                              classNames('active-tournaments-sponsor-section', {
                                'active-tournaments-sponsor-section-two': tournament?.sponsorImg && tournament?.prizeImg
                              })}
                            >
                              <span>{t('tournaments.sponsorTournaments')}</span>
                              <Media src={tournament?.sponsorImg} alt="x" />
                            </div>
                          )
                        }
                        {
                          tournament?.prizeImg && (
                            <div className={
                              classNames('active-tournaments-sponsor-section', {
                                'active-tournaments-sponsor-section-two': tournament?.sponsorImg && tournament?.prizeImg
                              })}
                            >
                              <span>{t('tournaments.mainPrize')}</span>
                              <Media src={tournament?.prizeImg} alt="x" />
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </Fragment>
                </>
              );
            }))}
          </ScrollAreaWrapper>
        ) : (
          <div className="d-flex align-items-center h-100 tournaments-empty-entries-old">{t('tournaments.futureTournamentsEmptyEntries')}</div>
        )}

        <TournamentInfo
          tournamentInfoModalOpen={tournamentInfoModalOpen}
          closeTournamentInfoModal={this.closeTournamentInfoModal}
          selectTournament={selectTournament}
          fontMode={fontMode}
        />

        {/*  </ReactTableContainer>  */}
        {uid && tournamentPlayers && openModal ? (
          <Modal container={'div > div'} returnFocusAfterClose={false} size="lg" isOpen={openModal} toggle={this.toggle} className={`old-modal root-font-${fontMode}`}>
            <ModalHeader
              toggle={this.toggle}
              close={
                <Media src={closeImg} className="notification-header-close" alt="X" onClick={this.toggle} />
              }
            >
              {t('tournaments.participants')/*t('tournaments.top')*/}
            </ModalHeader>
            <ModalBody>
              <Leaderboard tournament={getTournamentById(tournaments, tournamentId)} leaderboard={tournamentPlayers} tournamentId={tournamentId} uid={uid} />
            </ModalBody>
            <ModalFooter>
              <Button color="link" className="modal-footer-button" onClick={this.toggle}>{t('tournaments.close')}</Button>
            </ModalFooter>
          </Modal>
        ) : (null)}

        <Modal container={'div > div'} isOpen={privateTournamentConfirm} toggle={() => this.closePrivateTournamentEnter()} className={`old-modal notification root-font-${fontMode}`} >
          <ModalHeader
            className="notification-header"
            close={
              <Media src={closeImg} className="notification-header-close" alt="X" onClick={() => this.closePrivateTournamentEnter()} />
            }
          >
            <Row>
              <Col>
                <div className="tournaments-join-message-old">
                  {t('tournaments.joinTournament')}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="tournaments-join-message-old-body">
                  {t('tournaments.joinTournamentMessage', { entryFee: tournamentToJoinFee })}
                  <Media className="tournaments-join-message-image" src={coinImg} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="tournaments-join-message-old-body">
                  {t('tournaments.enterCode')}
                </div>
              </Col>
            </Row>
          </ModalHeader>
          <ModalBody className="notification-body">
            <Row>
              <Col>
                {privateTournamentConfirmError && (
                  <div className="room-password-error">
                    {t(`notifications:${privateTournamentConfirmError}`)}
                  </div>
                )}
              </Col>
            </Row>
            <Input
              className="room-password-digit"
              type="text"
              name={0}
              id="digit1"
              value={password[0] || ''}
              onChange={this.handleChangeDigit}
              innerRef={this.digit1}
            />
            <Input
              className="room-password-digit"
              type="text"
              name={1}
              id="digit2"
              value={password[1] || ''}
              onChange={this.handleChangeDigit}
              innerRef={this.digit2}
            />
            <Input
              className="room-password-digit"
              type="text"
              name={2}
              id="digit3"
              value={password[2] || ''}
              onChange={this.handleChangeDigit}
              innerRef={this.digit3}
            />
            <Input
              className="room-password-digit"
              type="text"
              name={3}
              id="digit4"
              value={password[3] || ''}
              onChange={this.handleChangeDigit}
              innerRef={this.digit4}
            />
          </ModalBody>
          <ModalFooter className="notification-footer">
            <Button color="link" className="btn notification-footer-button" onClick={() => this.joinPrivateTournamentClicked()}>
              { t('tournaments.register') }
            </Button>
            <Button color="link" className="btn notification-footer-button" onClick={() => this.closePrivateTournamentEnter()}>
              { t('common.close') }
            </Button>
          </ModalFooter>
        </Modal>


        <Modal container={'div > div'} returnFocusAfterClose={false} isOpen={openJoinModal} toggle={this.toggleJoin} className={`old-modal root-font-${fontMode}`}>
          <ModalHeader
            toggle={this.toggleJoin}
            close={
              <Media src={closeImg} className="notification-header-close" alt="X" onClick={this.toggleJoin} />
            }
          >
            {t('tournaments.joinTournament')}
          </ModalHeader>
          <ModalBody>

            {tournamentConfirmError && (
              <Row>
                <Col>
                  <div className="room-password-error">
                    {t(`notifications:${tournamentConfirmError}`)}
                  </div>
                </Col>
              </Row>
            )}

            <div className="tournaments-join-message text-center">
              {t('tournaments.joinTournamentMessage', { entryFee: tournamentToJoinFee })}
              <Media className="tournaments-join-message-image" src={coinImg} />
            </div>

            {/*  {`Vai tiešām vēlies pievienoties turnīram? Dalības maksa ${tournamentToJoin && tournaments[tournamentToJoin] && tournaments[tournamentToJoin].entryFee} EUR`}  */}
          </ModalBody>
          <ModalFooter>
            <Button color="link" className="modal-footer-button" onClick={() => this.joinTournament(tournamentToJoin)}>
              {t('tournaments.register')}
            </Button>
            <Button color="link" className="modal-footer-button" onClick={this.toggleJoin}>{t('tournaments.close')}</Button>
          </ModalFooter>
        </Modal>


        <Modal container={'div > div'} returnFocusAfterClose={false} isOpen={openLeaveModal} toggle={this.toggleLeave} className={`old-modal root-font-${fontMode}`}>
          <ModalHeader
            toggle={this.toggleLeave}
            close={
              <Media src={closeImg} className="notification-header-close" alt="X" onClick={this.toggleLeave} />
            }
          >
            {t('tournaments.leaveTournament')}
          </ModalHeader>
          <ModalBody className="notification-body text-center">
            {t('tournaments.leaveTournamentBody')}
            <p>{t('tournaments.leaveTournamentWarning')}</p>

            <div className="w-100 d-flex align-items-center">
              <Media src={coinStack} />
            </div>

            <span className="coins-warning">{`-${renderNum(tournamentToLeaveFee)} ${t('common.coins')}`}</span>

            <FormGroup className="mb-0">
              <Label for="leaveReason">{t('tournaments.leaveTournamentReason')}</Label>
              <div>
                <Input
                  type="textarea"
                  name="leaveReason"
                  id="leaveReason"
                  placeholder=""
                  value={leaveReason}
                  maxLength={500}
                  onChange={this.handleLeaveReason}
                  rows={3}
                  style={{ resize: 'none' }}
                />
                <div className="float-right">
                  {curLength}/500
                </div>
                {leaveReasonErr && (
                  <div className="float-left" style={{background: '#c44c4c', color: 'white'}}>
                    {t('tournaments.leaveTournamentError')}
                  </div>
                )}
              </div>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="link" className="modal-footer-button" onClick={leaveReason ? () => this.leaveTournament(tournamentToLeave) : () => this.setState({leaveReasonErr: true})}>
              {t('tournaments.leave')}
            </Button>
            <Button color="link" className="modal-footer-button" onClick={this.toggleLeave}>{t('tournaments.close')}</Button>
          </ModalFooter>
        </Modal>


        <Modal container={'div > div'} isOpen={lowBalanceError} toggle={() => this.closeLowBalanceError()} className={`notification old-modal root-font-${fontMode}`}>
          <ModalHeader
            className="notification-header"
            close={
              <Media src={closeImg} className="notification-header-close" alt="X" onClick={() => this.closeLowBalanceError()} />
          }
          >
            {t('common:home.notifications')}
          </ModalHeader>
          <ModalBody className="notification-body">
            {t('notifications:noMoneyTournamentDescription',
              {
                feeMaxLoss: selectTournament && selectTournament.bet && selectTournament.entryFee + 16 * parseInt(selectTournament.bet.split(':')[1], 10),
                bet: selectTournament?.bet,
                fee: selectTournament?.entryFee,
              })}
          </ModalBody>
          <ModalFooter className="notification-footer">
            <Button className="btn notification-footer-button" color="link" onClick={this.buyMoney}>{t('notifications:buyMoney')}</Button>
            <Button color="link" className="btn notification-footer-button" onClick={() => this.closeLowBalanceError()}>
              {t('common.cancel')}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal container={'div > div'} isOpen={purchaseTournamentTicketModal} toggle={() => this.togglePurchaseTournamentTicketModal()} className={`notification old-modal root-font-${fontMode}`}>
          <ModalHeader
            className="notification-header"
            close={
              <Media src={closeImg} className="notification-header-close" alt="X" onClick={() => this.togglePurchaseTournamentTicketModal()} />
          }
          >
            {t('common:home.notifications')}
          </ModalHeader>
          <ModalBody className="notification-body">
            {t('notifications:purchaseTournamentTicket')}
          </ModalBody>
          <ModalFooter className="notification-footer">
            <Button className="btn notification-footer-button" color="link" onClick={this.tournamentTicketBuyMoney}>{t('notifications:buyMoney')}</Button>
            <Button color="link" className="btn notification-footer-button" onClick={() => this.togglePurchaseTournamentTicketModal()}>
              {t('common.cancel')}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal container={'div > div'} isOpen={confirmTournamentTicketModal} toggle={() => this.closeTournamentTicketModal()} className={`notification old-modal root-font-${fontMode}`}>
          <ModalHeader
            className="notification-header"
            close={
              <Media src={closeImg} className="notification-header-close" alt="X" onClick={() => this.closeTournamentTicketModal()} />
          }
          >
            {t('common:home.notifications')}
          </ModalHeader>
          <ModalBody className="notification-body text-first-captialize">
            {(t('notifications:confirmTournamentTicket', {ticket: t(`notifications:${tournaments.filter(element => element.id === selectedTournamentId)[0]?.tournamentType}`)})).toLowerCase()}
          </ModalBody>
          <ModalFooter className="notification-footer">
            <Button className="btn notification-footer-button" color="link" onClick={() => this.tournamentTicketBuyMoney()}>{member?.tournamentTickets && member?.tournamentTickets[(tournaments.filter(element => element.id === selectedTournamentId)[0]?.tournamentType)] ? t('notifications:ok') : t('notifications:gotoShop')}</Button>
            <Button color="link" className="btn notification-footer-button" onClick={() => this.closeTournamentTicketModal()}>
              {t('common.cancel')}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal container={'div > div'} isOpen={isRestrictionModal} toggle={() => this.closeRestrictionsModal()} className={`notification old-modal root-font-${fontMode}`}>
          <ModalHeader
            className="notification-header"
            close={
              <Media src={closeImg} className="notification-header-close" alt="X" onClick={() => this.closeRestrictionsModal()} />
          }
          >
            {t('common:home.notifications')}
          </ModalHeader>
          <ModalBody className="notification-body">
            <div className='d-flex flex-column gap-5 items-center'>
              <div className='fs-4 fw-bold'>
                {t('common.listOfRequirements')}
              </div>
              {tournaments.filter(item => item.id === selectedTournamentId)[0]?.levelFrom && tournaments.filter(item => item.id === selectedTournamentId)[0]?.levelTo && (
                <div className='d-flex flex-row gap-5'>
                    <div className='fs-4 fw-bold'>
                    {t('common.level')}
                  </div>
                  <div className='fs-4 fw-normal'>
                    {`${tournaments.filter(item => item.id === selectedTournamentId)[0]?.levelFrom}–${tournaments.filter(item => item.id === selectedTournamentId)[0]?.levelTo}`}
                  </div>
                </div>
              )}
              {tournaments.filter(item => item.id === selectedTournamentId)[0]?.balanceFrom && tournaments.filter(item => item.id === selectedTournamentId)[0]?.balanceTo && (
                <div className='d-flex flex-row gap-5'>
                  <div className='fs-4 fw-bold'>
                    {t('common.balance')}
                  </div>
                  <div className='fs-4 fw-normal'>
                    {`${tournaments.filter(item => item.id === selectedTournamentId)[0]?.balanceFrom}–${tournaments.filter(item => item.id === selectedTournamentId)[0]?.balanceTo}`}
                  </div>
                </div>
              )}
              {tournaments.filter(item => item.id === selectedTournamentId)[0]?.pointsFrom && tournaments.filter(item => item.id === selectedTournamentId)[0]?.pointsTo && (
                <div className='d-flex flex-row gap-5'>
                  <div className='fs-4 fw-bold'>
                    {t('common.points')}
                  </div>
                  <div className='fs-4 fw-normal'>
                    {`${tournaments.filter(item => item.id === selectedTournamentId)[0]?.pointsFrom}–${tournaments.filter(item => item.id === selectedTournamentId)[0]?.pointsTo}`}
                  </div>
                </div>
              )}
              {tournaments.filter(item => item.id === selectedTournamentId)[0]?.playedGamesFrom && tournaments.filter(item => item.id === selectedTournamentId)[0]?.playedGamesTo && (
                <div className='d-flex flex-row gap-5'>
                  <div className='fs-4 fw-bold'>
                    {t('common.playedGames')}
                  </div>
                  <div className='fs-4 fw-normal'>
                    {`${tournaments.filter(item => item.id === selectedTournamentId)[0]?.playedGamesFrom}–${tournaments.filter(item => item.id === selectedTournamentId)[0]?.playedGamesTo}`}
                  </div>
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter className="notification-footer">
            <Button color="link" className="btn notification-footer-button" onClick={() => this.closeRestrictionsModal()}>
              {t('common.cancel')}
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => ({
  registeredTournament: state.member.registeredTournament,
  uid: state.member.uid || '',
  offset: state.member.offset || 0,
  tournaments: (state.tournaments && state.tournaments.tournaments) ? state.tournaments.tournaments : [],
  myTournamentsData: (state.tournaments && state.tournaments.myTournamentsData) ? state.tournaments.myTournamentsData : {},
  tournamentPlayers: (state.tournaments && state.tournaments.tournamentPlayers) ? state.tournaments.tournamentPlayers : {},
  name: state.member.name,
  member: state.member,
  joinTournamentIdTrigger: state.state.joinTournamentIdTrigger,
});

const mapDispatchToProps = {
  pauseTournamentFunc: pauseTournament,
  returnToTournamentFunc: returnToTournament,
  leaveTournamentFunc: leaveTournament,
  joinTournamentFunc: joinTournament,
  fetchTournamentPlayers: getTournamentPlayers,
  fetchTournamentActiveRooms: getTournamentActiveRooms,
  setAddPaymentInfo: addPaymentInfo,
  setHandlePaymentInfoStatus: updatePaymentInfoStatus,
  setScreenViewNew: setUserScreenViewNew,
  setJoinTournamentIdTriggerFunc: setJoinTournamentIdTrigger,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(['common', 'notifications'])(TournamentsPlan));
